export default __webpack_public_path__ + "static/media/arrow-close.de4761bf.svg";